/**
 * Lightweight pub/sub for cross-PRD coordination.
 *
 * Per the synthesized plan: PRD-004's project-switch confirmation needs to
 * cancel PRD-001's running export jobs. Direct context-to-context imports
 * couple the PRDs; this bus keeps them loosely connected. PRD-001 will
 * subscribe to `project:switching` and react.
 *
 * Event vocabulary is curated; new events should be added explicitly here
 * and documented in the relevant PRD.
 */

export type SessionEventName = "auth:logout" | "project:switching" | "project:switched";

type Listener = (payload?: unknown) => void;

const listeners = new Map<SessionEventName, Set<Listener>>();

export const sessionEvents = {
    on(event: SessionEventName, fn: Listener): () => void {
        let set = listeners.get(event);
        if (!set) {
            set = new Set();
            listeners.set(event, set);
        }
        set.add(fn);
        return () => set!.delete(fn);
    },
    emit(event: SessionEventName, payload?: unknown): void {
        listeners.get(event)?.forEach((fn) => fn(payload));
    },
};

/**
 * Test-only reset.
 */
export function __resetSessionEventsForTests(): void {
    listeners.clear();
}
